<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-19 10:42:30
 * @LastEditTime: 2021-01-20 11:32:33
 * @LastEditors: daikeyi
 -->
<template>
<div id='page_Container'>
    <div class="page">
        <div id='main-container'>
            <!-- <div style="height: 100%"> -->
            <div id="dotManage" :class="{ active: active }">
                <!-- 搜索区域 -->
                <!-- <div class="search" @click="searchDot">
                    <div class="search-input">{{searchResult}}</div>
                    <div class="search-button">
                        <img src="../../assets/img/dot/search@2x.png" alt="">
                    </div>
                </div> -->
                <div id="map-container"></div>
                <!-- 信息窗体 -->
                <div class="infoWindow">
                    <div class="info">
                        <span class="outletName">{{ markerInfo.outletName }}</span>
                        <span class="locationName">{{ markerInfo.locationName }}</span>
                    </div>
                    <div class="img">
                        <!-- <img :src='markerInfo.img'> -->
                        <div class="imgs">
                            <div @click="imgshowFun()" :style="{backgroundImage: 'url('+markerInfo.img+')'}" class="zoomImage" v-show="markerInfo.img"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </div>
        <van-popup v-model="show" class="vanPopupStyle">
            <div class="dialogImg">
                <img :src="markerInfo.img" alt="" class="showImg">
                <img class="close-btn" @click="closeFun" src="@/assets/img/dot/Group13@3x.png" alt="">
            </div>
        </van-popup>
    </div>
</div>
</template>

<script>
import AMap from '@/utils/map/map.js';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
export default {
    data() {
        return {
            map: {},
            isNeedShowSearchResult: true,
            timer: null,
            searchResult: '请输入网点地址',
            hiddenData: true,
            searchResultList: [],
            currentMapSite: {
                currentSitePoint: {},
                currentLng: '',
                currentLat: '',
                currentAddress: ''
            },
            searchType: '3',
            imgPath: require('@/assets/img/dot/wechatDot1@3x.png'),
            imgPathActive: require('@/assets/img/dot/wechatDot2@3x.png'),
            markerList: [],
            markerInfo: {
                locationName: '',
                outletName: '',
                img: ''
            },
            oldMarker: null,
            active: false,
            show: false
        };
    },
    esvShow: function () {
        this.init();
    },
    methods: {
        init() {
            document.title = '网点';
            this.map = new AMap({
                id: 'map-container',
                initData: {
                    resizeEnable: true,
                    zoom: 4,
                    center: [116.39, 39.9]
                }
            });

            this.map.on('complete', () => {
                this.initMap();
                this.queryDot();
                this.searchResult = this.$route.query.searchResult || '请输入网点地址';
                const {
                    lng,
                    lat
                } = this.$route.query;
                if (this.$route.query.searchResult && this.$route.query.searchAddress === 'detail') {
                    this.getSearchAddressDetail(this.searchResult, lng, lat);
                } else {
                    this.searchAddressFirstResult();
                }
            });
        },
        closeFun() {
            this.show = false;
        },
        imgshowFun() {
            this.show = true;
        },
        // 设置 marker 的点击事件&& 显示信息窗
        setMarkerInfoWindow(marker) {
            marker.on('click', (e) => {
                const markerItem = e.target.getExtData();
                console.log(markerItem);
                this.markerInfo = {
                    locationName: markerItem.locationName,
                    outletName: markerItem.outletName,
                    img: markerItem.img
                };
                if (this.oldMarker) {
                    this.map.updateMakerIcon(this.oldMarker, this.imgPath, 24, 30);
                }
                this.map.updateMakerIcon(marker, this.imgPathActive, 30, 38);
                this.active = true;
                this.oldMarker = marker;
            });
        },
        queryDot() {
            const ths = this;
            this.$doRequest({
                url: '/outlet/queryOutletOffline',
                params: {},
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    ths.finished = true;
                    clearToastLoading(ths.loading);
                }
            }, (data) => {
                console.log(data);
                const list = data.result;
                this.markerList = [];
                list.forEach((item) => {
                    console.log(item);

                    // console.log(lng, lat);

                    this.setMarkerList(item);
                    this.map.addMarker(this.markerList);
                });
                this.map.setFitView(this.markerList);
            });
        },
        setMarkerList(info) {
            const [lng, lat] = info.locationNo.split(',');
            const Icon = this.map.createIcon(this.imgPath, 24, 30);
            const currentMarker = this.map.createMarker(Icon, lng, lat, {}, -12, -37);
            currentMarker.setExtData(info);
            this.markerList.push(currentMarker);
            this.setMarkerInfoWindow(currentMarker);
        },
        searchDot() {
            this.esvOpenPage({
                name: 'searchDot',
                query: {
                    searchType: this.searchType,
                    searchResult: this.searchResult === '请输入网点地址' ? '' : this.searchResult
                }
            });
        },
        // 地图初始化
        initMap() {
            // console.dir(this.map.getMapInstance())
            // let aMap = this.map.getMapInstance();
            // let geolocation = new aMap.Geolocation({
            //     zoomToAccuracy: true
            //     // useNative: true
            // });
            // let toolBar = new aMap.ToolBar({
            // // 简易缩放模式，默认为 false
            //     liteStyle: true

            // });
            // this.map.usePlugins('AMap.Geolocation', geolocation, 'control');
            // this.map.usePlugins('AMap.ToolBar', toolBar, 'control');
            this.map.add('click', this.clickListener);
        },
        clickListener() {
            if (this.oldMarker) {
                this.map.updateMakerIcon(this.oldMarker, this.imgPath, 24, 30);
                this.markerInfo = {
                    locationName: '',
                    outletName: '',
                    img: ''
                };
            }
            this.active = false;
        },
        // 根据文字输入搜索检索地址结果
        searchAddressDetail(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            if (query !== '') {
                this.timer = setTimeout(() => {
                    this.map
                        .search(query)
                        .then((res) => {
                            this.hiddenData = true;
                            this.searchResultList = [];
                            this.searchResultList = res.map((addressItem, index) => {
                                return {
                                    value: addressItem.name,
                                    label: addressItem.name,
                                    district: addressItem.district,
                                    lng: addressItem.location.lng,
                                    lat: addressItem.location.lat
                                };
                            });
                        })
                        .catch(() => {
                            this.searchResultList = [];
                            this.hiddenData = false;
                        });
                }, 300);
            } else {
                this.searchResultList = [];
                this.hiddenData = true;
            }
        },
        // 选择下拉框的时候定位地址
        getSearchAddressDetail(query, lng, lat) {
            console.log('details');
            if (lng && lat) {
                this.searchResult = query;
                this.isNeedShowSearchResult = false;
                this.map.setZoomAndCenter(16, lng, lat);
            } else {
                this.map
                    .toLocation(query)
                    .then((res) => {
                        this.searchResult = query;
                        this.isNeedShowSearchResult = false;
                        this.map.setZoomAndCenter(16, res.geocodes[0].location.lng, res.geocodes[0].location.lat);
                    })
                    .catch(() => {
                        this.$Message.error('无法找到该地址的详细定位');
                    });
            }
        },
        // 定位到模糊搜索的第一条结果
        locationFirstResult() {
            this.map
                .search(this.searchResult)
                .then((res) => {
                    const lng = res[0].location.lng;
                    const lat = res[0].location.lat;
                    this.map.setZoomAndCenter(16, lng, lat);
                    this.isNeedShowSearchResult = false;
                    this.isEnter = true;
                    this.isShowSave = true;
                    this.LocationMode = 'editing';
                })
                .catch(() => {});
        },
        // 获取搜索结果的第一条
        searchAddressFirstResult() {
            if (this.searchResult !== '') {
                this.map
                    .toLocation(this.searchResult)
                    .then((res) => {
                        const lng = res.geocodes[0].location.lng;
                        const lat = res.geocodes[0].location.lat;
                        this.map.setZoomAndCenter(16, lng, lat);
                    })
                    .catch(() => {
                        this.locationFirstResult();
                    });
            }
        },

        saveCurrentMapSite(siteObject) {
            this.currentMapSite = siteObject;
        }
    },
    watch: {
        searchResult(value) {
            if (this.isNeedShowSearchResult) this.searchAddressDetail(value);
        }
    }
};
</script>

<style lang="scss">
#dotManage {
    // height: calc(100% - 50px);
    height: 100%;
    position: relative;

    .amap-geolocation-con {
        z-index: 50 !important
    }

    .amap-logo,
    .amap-copyright {
        display: none !important;
    }

    .infoWindow {
        position: absolute;
        height: 98px;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        padding: 18px 20px;

        span {
            display: block
        }

        display: none;
        justify-content: space-between;

        .info {
            flex: 4;

            // overflow: hidden;
            .locationName {
                font-size: 13px;
                color: #666666;
            }

            .outletName {
                font-size: 17px;
                color: #414141;
            }
        }

        .img {
            flex: 1;

            // float: right;
            .imgs {
                float: right;
                width: 62px;
                height: 62px;

                // overflow: hidden;
                .zoomImage {
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    overflow: hidden;
                    background-position: center center;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    background-size: cover;
                }

                // img {
                //     max-width: 100%;
                //     // max-height: 100%;
                //     width: auto;
                //     height: auto;
                // }
            }

            img {
                width: 80px;
                height: 100%;
                // width: 100%;
            }
        }
    }

    #map-container {
        // height: 470px;
        height: 100%;
        position: relative;
    }

    .bodyDiv {
        height: 100%;
    }

    .ivu-modal-content {
        height: 100%;
    }

    .siteSearch {
        position: absolute;
        right: 5px;
        z-index: 11;
        cursor: pointer;
        bottom: 3px;
    }

    .search {
        position: absolute;
        z-index: 10;
        height: 40px;
        background: #fff;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
        width: calc(100% - 20px);
        margin: 0 10px;
        top: 10px;

        &-button {
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            float: right;
            padding: 12px;

            img {
                width: 15px;
                display: block;
            }
        }

        &-tips {
            background: #fff;
            height: 0px;
            text-align: center;
            visibility: hidden;
            line-height: 26px;
            color: #888;

            &-show {
                animation: toogleIn 0.2s forwards 1 linear;
            }

            &-hide {
                visibility: hidden;
            }
        }

        &-logo {
            cursor: pointer;
            width: 24%;
            vertical-align: middle;
        }

        &-input {
            width: calc(100% - 40px);
            outline: none;
            border: none;
            font-size: 14px;
            height: 40px;
            line-height: 40px;
            float: left;
            color: #BEBEC5;
            text-indent: 10px;
        }

        &-input:placeholder {
            color: #888;
        }

        &-click {
            cursor: pointer;
            transition: all 0.2s linear;
        }

        &-click:hover {
            color: #a53283;
            transition: color 0.2s linear;
        }
    }
}

.vanPopupStyle {
    width: 100%;
    height: 100%;
    background: transparent;

    .dialogImg {
        position: relative;

        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
        }

        .showImg {}

        .close-btn {
            position: absolute;
            top: 11px;
            left: 11px;
            width: 32px;
            height: 32px;
        }

    }
}

#dotManage.active {
    padding-bottom: 98px;

    .infoWindow {
        display: flex !important;
    }
}
</style>
